import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'techDoc.internal.search.title',
        defaultMessage: 'Search Engine'
    },
    REQUEST_DETAIL_SECTION: {
        id: 'techDoc.internal.search.requestDetailSection',
        defaultMessage: 'Request details'
    },
    // search criteria
    INTERNAL_TICKET_NUMBER: {
        id: 'techDoc.internal.search.requestDetailSection.ticketNumber',
        defaultMessage: 'Internal Ticket number'
    },
    DEALER_TICKET_NUMBER: {
        id: 'techDoc.internal.search.requestDetailSection.dealerTicketNumber',
        defaultMessage: 'Dealer ticket'
    },
    DEALER_FORM_TYPE: {
        id: 'techDoc.internal.search.requestDetailSection.dealerFormType',
        defaultMessage: 'Dealer Form Type'
    },
    DEALER_COUNTRY_CODE_3: {
        id: 'techDoc.internal.search.requestDetailSection.countryCode3',
        defaultMessage: 'Country Code'
    },
    TYPE_OF_REQUEST: {
        id: 'techDoc.internal.search.requestDetailSection.typeOfRequest',
        defaultMessage: 'Request type'
    },
    REQUEST_STATUS: {
        id: 'techDoc.internal.search.requestDetailSection.requestStatus',
        defaultMessage: 'Request Status'
    },
    SG_REQUESTER: {
        id: 'techDoc.internal.search.requestDetailSection.sgRequester',
        defaultMessage: 'SG requestor'
    },
    PARTNER_NAME: {
        id: 'techDoc.internal.search.requestDetailSection.partnerName',
        defaultMessage: 'Partner Name'
    },
    REQUESTOR_IPN: {
        id: 'techDoc.internal.search.requestDetailSection.requestorIpn',
        defaultMessage: 'Requestor (IPN)'
    },
    REQUEST_FOR_PARTNER: {
        id: 'techDoc.internal.search.requestDetailSection.requestForPartner',
        defaultMessage: 'Partner ? (Yes/No)'
    },
    CREATED_AT_INTERNAL_TICKET_FROM: {
        id: 'techDoc.internal.search.requestDetailSection.createdAtInternalTicketFrom',
        defaultMessage: 'Creation Date of the Internal Ticket From'
    },

    CREATED_AT_INTERNAL_TICKET_TO: {
        id: 'techDoc.internal.search.requestDetailSection.createdAtInternalTicketTo',
        defaultMessage: 'Creation Date of the Internal Ticket To'
    },

     VEHICLE_DETAIL_SECTION: {
        id: 'techDoc.internal.search.vehicleDetailSection',
        defaultMessage: 'Vehicle details'
    },
    VIN: {
        id: 'techDoc.internal.search.vehicleDetailSection.vin',
        defaultMessage: 'VIN number'
    },
    MANUFACTURE_DATE: {
        id: 'techDoc.internal.search.vehicleDetailSection.manufactureDate',
        defaultMessage: 'Manufacturing date'
    },
    TAPV: {
        id: 'techDoc.internal.search.vehicleDetailSection.tapv',
        defaultMessage: 'TAPV'
    },
    VEHICLE_FAMILY: {
        id: 'techDoc.internal.search.vehicleDetailSection.vehicleFamily',
        defaultMessage: 'Vehicle Family'
    },
    VEHICLE_BRAND: {
        id: 'techDoc.internal.search.vehicleDetailSection.vehicleBrand',
        defaultMessage: 'Vehicle Brand'
    },

    PART_DETAIL_SECTION: {
        id: 'techDoc.internal.search.partDetailSection',
        defaultMessage: 'Part details'
    },
    N_REFERENCE_CAUSING_PROBLEM: {
        id: 'techDoc.internal.search.vehicleDetailSection.nReferenceCausingProblem',
        defaultMessage: 'N° reference causing problem'
    },
    MANAGEMENT_GROUP: {
        id: 'techDoc.internal.search.vehicleDetailSection.mangementGroup',
        defaultMessage: 'Management Group'
    },
    N_REFERENCE_FOR_REPLACEMENT: {
        id: 'techDoc.internal.search.vehicleDetailSection.nReferenceForReplacement',
        defaultMessage: 'N° reference for Replacement'
    },
    CATALOG_NUMBER: {
        id: 'techDoc.internal.search.vehicleDetailSection.catalogNumber',
        defaultMessage: 'Catalog Number'
    },
    PLATE_NUMBER: {
        id: 'techDoc.internal.search.vehicleDetailSection.plateNumber',
        defaultMessage: 'Plate Number'
    },
    PART_MARKING: {
        id: 'techDoc.internal.search.vehicleDetailSection.partMarking',
        defaultMessage: 'Part Marking'
    },

    // searching options
    SEARCH_OPTION_SECTION : {
        id: 'techDoc.internal.search.options',
        defaultMessage: 'Searching option'
    },
    FULLTEXT_SEARCH : {
        id: 'techDoc.internal.search.options.fulltextSearch',
        defaultMessage: 'Fulltext'
    },
    ATTACHMENTS_ONLY: {
        id: 'techDoc.internal.search.options.onlyTicketsWithAttachments',
        defaultMessage: 'Only tickets with Attachments'
    },

    VISIBLE_COLUMNS: {
        id: 'techDoc.internal.search.label.visibleColumns',
        defaultMessage: 'Visible columns'
    },


    // table
    TABLE_TICKET_NUMBER: {
        id: 'techDoc.internal.search.table.ticketNumber',
        defaultMessage: 'Internal Ticket number'
    },
    TABLE_REQUEST_TYPE: {
        id: 'techDoc.internal.search.table.requestType',
        defaultMessage: 'Request type'
    },
    TABLE_REQUEST_STATUS: {
        id: 'techDoc.internal.search.table.status',
        defaultMessage: 'Request Status'
    },
    TABLE_PRIORITY: {
        id: 'techDoc.internal.search.table.priority',
        defaultMessage: 'Priority'
    },
    TABLE_PRIORITY_TYPE: {
        id: 'techDoc.internal.search.table.priorityType',
        defaultMessage: 'Priority Type'
    },
    TABLE_DEALER_TICKET_NUMBER: {
        id: 'techDoc.internal.search.table.dealerTicketNo',
        defaultMessage: 'Dealer Ticket No.'
    },
    TABLE_DEALER_FORM_TYPE: {
        id: 'techDoc.internal.search.table.dealerTicketFormType',
        defaultMessage: 'Dealer Form Type'
    },
    TABLE_IT_CREATION_TIME: {
        id: 'techDoc.internal.search.table.itCreationDate',
        defaultMessage: 'IT Creation Date'
    },
    TABLE_IT_CREATED_BY: {
        id: 'techDoc.internal.search.table.itCreatedBy',
        defaultMessage: 'IT Created by (IPN)'
    },
    TABLE_SG_REQUESTOR: {
        id: 'techDoc.internal.search.table.sgRequestor',
        defaultMessage: 'SG Requestor'
    },
    TABLE_ASSIGNED_SOLUTION_GROUP: {
        id: 'techDoc.internal.search.table.assignedSolutionGroup',
        defaultMessage: 'Assigned SG'
    },
    TABLE_DEALER_CLIENT_ID: {
        id: 'techDoc.internal.search.table.clientId',
        defaultMessage: 'Client ID'
    },
    TABLE_DEALER_REGION: {
        id: 'techDoc.internal.search.table.region',
        defaultMessage: 'Region'
    },
    TABLE_DEALER_COUNTRY_CODE_3: {
        id: 'techDoc.internal.search.table.countryCode3',
        defaultMessage: 'Country Code'
    },
    TABLE_IT_DEALER_NUMBER: {
        id: 'techDoc.internal.search.table.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    TABLE_PART_NUMBER: {
        id: 'techDoc.internal.search.table.partNumber',
        defaultMessage: 'Part No.'
    },
    TABLE_MANAGEMENT_GROUP: {
        id: 'techDoc.internal.search.table.managementGroup',
        defaultMessage: 'Management Group'
    },
    TABLE_PARTNER: {
        id: 'techDoc.internal.search.table.partner',
        defaultMessage: 'Partner'
    },
    TABLE_PARTNER_NAME: {
        id: 'techDoc.internal.search.table.partnerName',
        defaultMessage: 'Partner Name'
    },
    TABLE_IT_LAST_STATUS_DATE: {
        id: 'techDoc.internal.search.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TABLE_IT_LAST_EDITOR: {
        id: 'techDoc.internal.search.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
});

export default messages;
